import classNames from 'classnames';
import React, {ChangeEvent} from 'react';

import {TextField} from '@albert-io/atomic';
import {useStudentDashboard} from '../StudentDashboard/StudentDashboard.store';

const ERROR_MESSAGE =
  "We didn't recognize that code. Please verify it with your teacher and try again.";

interface Props extends PropsWithClassNameOptional {
  hideLabel?: boolean;
  inert?: boolean;
}

export default function JoinClassroomInput({className, hideLabel = false, inert = false}: Props) {
  const isError = useStudentDashboard((state) => state.isStudentEnrollmentError);
  const isRequestPending = useStudentDashboard((state) => state.isStudentEnrollmentPending);
  const setIsError = useStudentDashboard((state) => state.setIsStudentEnrollmentError);
  const setValue = useStudentDashboard((state) => state.setClassroomCode);
  const value = useStudentDashboard((state) => state.classroomCode);

  return (
    <TextField
      aria-label='Enrollment code'
      border
      className={classNames(className, 'mb-x1')}
      data-testid='join-code-form__input'
      disabled={isRequestPending}
      error={isError && !inert}
      id='enrollmentCodeField'
      label={hideLabel ? undefined : 'Enter enrollment code:'}
      message={isError && !inert ? ERROR_MESSAGE : undefined}
      onChange={(e: ChangeEvent<HTMLInputElement>) => {
        setIsError(false);
        setValue(e.target.value.trim().toUpperCase());
      }}
      placeholder='Enter code'
      type='text'
      value={inert ? '' : value}
    />
  );
}
